import { CustomersCount, LiensesOffer, OwnerLeave, RecurringAmount, SalesPercent, YesNo } from "./Enums";

export class Risk {

    ID: string;
    STAGE: number;

    DIV_CUSTOMERS: CustomersCount;
    DIV_SINGLE_CLIENT_PERCENT: YesNo;
    DIV_MORE_FIFTY: YesNo;
    DIV_SALES_PERCENT: SalesPercent;
    DIV_CONTRACTS: YesNo;
    DIV_SALES_LOST: YesNo;
    DIV_VENDOR_PERCENT: YesNo;
    DIV_SIMILAR_VENDOR: YesNo;

    PG_OWNER_LEAVE: OwnerLeave;

    BE_LICENSES: YesNo;
    BE_LICENSES_REQ: LiensesOffer;

    RR_IS_RECURRING: YesNo;
    RR_RECURRING_AMOUNT: RecurringAmount;

    OPT_DV: boolean;
    OPT_PG: boolean;
    OPT_BE: boolean;
    OPT_RR: boolean;

    static parse(json: any): Risk {
        if (json) {
            const r = new Risk();
            r.ID = json.ID;
            r.STAGE = json.STAGE;
            
            r.DIV_CUSTOMERS = CustomersCount[<string>json.DIV_CUSTOMERS];
            r.DIV_SINGLE_CLIENT_PERCENT = YesNo[<string>json.DIV_SINGLE_CLIENT_PERCENT];
            r.DIV_MORE_FIFTY = YesNo[<string>json.DIV_MORE_FIFTY];
            r.DIV_SALES_PERCENT = SalesPercent[<string>json.DIV_SALES_PERCENT];
            r.DIV_CONTRACTS = YesNo[<string>json.DIV_CONTRACTS];
            r.DIV_SALES_LOST = YesNo[<string>json.DIV_SALES_LOST];
            r.DIV_VENDOR_PERCENT = YesNo[<string>json.DIV_VENDOR_PERCENT];
            r.DIV_SIMILAR_VENDOR = YesNo[<string>json.DIV_SIMILAR_VENDOR];

            r.PG_OWNER_LEAVE = OwnerLeave[<string>json.PG_OWNER_LEAVE];

            r.BE_LICENSES = YesNo[<string>json.BE_LICENSES];
            r.BE_LICENSES_REQ = LiensesOffer[<string>json.BE_LICENSES_REQ];

            r.RR_IS_RECURRING = YesNo[<string>json.RR_IS_RECURRING];
            r.RR_RECURRING_AMOUNT = RecurringAmount[<string>json.RR_RECURRING_AMOUNT];

            r.OPT_DV = json.OPT_DV;
            r.OPT_PG = json.OPT_PG;
            r.OPT_BE = json.OPT_BE;
            r.OPT_RR = json.OPT_RR;

            return r;
        } else { return null; }
    }

}